module.exports = __webpack_public_path__ + "img/blockGq2-1.67563400.svg";